module.exports = __webpack_public_path__ + "static/img/square-vimeo.8bf785b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integration/square-vimeo.png
// module id = A9kC
// module chunks = 134